// WHAT CAN BE CHANGED?
// You can make style changes accordingly

<template>
    <div id="listen" class="page">
        <div id="listen__currently-live">
            <hr><h1>Nu live</h1><hr>
        </div>
    </div>
</template>

<script>
export default {
    name: "Listen",
};
</script>

<style lang="scss">
$listen__background--colour: linear-gradient(to right, #ff5000, #ffae32);
$listen__text--colour: #ffffff;
$listen__text--font: "Lato";

#listen {
    position: fixed;
    height: 100vh;
    width: 100%;
    background: $listen__background--colour;
    padding-top: 0px !important;

    #listen__currently-live {
        // max-width: 768px;
        max-width: 85%;
        margin: auto;
        display: grid;
        align-items: center;
        grid-template-columns: 1fr 110px 1fr;
        margin-top: 40px;
        hr {
            border: 1px solid white;
        }
        h1 {
            font-family: $listen__text--font;
            font-size: 23px;
            color: $listen__text--colour;
            font-style: italic;
            font-weight: normal;
            text-align: center;
        }
    }
}

.listen-on-page {
    background-image: none !important;
    box-shadow: none !important;
    bottom: unset !important;
    height: 100%;

    #radioplayer__data {
        grid-template-columns: unset !important;
        grid-template-rows: 1fr 80px 140px;
        justify-items: center;
        width: 100%;
        height: unset !important;
        padding: 100px 0px 140px;
        margin-bottom: env(safe-area-inset-bottom, 20px);

        #radioplayer__data__cover {
            margin-left: 0px !important;
            height: 100% !important;
            width: 100% !important;
        }

        #radioplayer__data__labels {
            text-align: center;
            font-size: 23px;
        }

        #radioplayer__data__button-container {
            align-self: end;
            background-color: white;
            border-radius: 999px;
        
            display: flex;
            justify-content: center;
            align-items: center;
            width: 95px;
            height: 95px;
            box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.2);

            button {
                height: 95px;
                width: 95px;
            }

            .icon-play {
                background: url(../assets/radioplayer/icon-play-orange.svg) !important;
                background-repeat: no-repeat !important;
                background-position: center !important;
                margin-left: 8px;
                height: 40px;
                width: 40px;
            }

            .icon-pause {
                background: url(../assets/radioplayer/icon-pause-orange.svg) !important;
                background-repeat: no-repeat !important;
                background-position: center !important;
                height: 40px;
                width: 40px;
            }
        }
    }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    #listen {

    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    #listen {

    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    #listen {

    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    #listen {

    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    #listen {
       
    }
}
</style>